//= ========================================================================
import React from 'react';
import { View } from 'react-native-web';
import FullPageSimulator from '../../FullPageSimulator';
import PackageCard from '../../../AuxiliaryComponent/OperatorComponent/PackageCard';
import AccountBalance from '../../../AuxiliaryComponent/AmountSim/AccountBalance';
import BottomPanelButton from '../../../AuxiliaryComponent/ButtonComponent/BottomPanelButton';

const SelectOperatorFP = ({
  globJSON,
  simPlatform,
  headlineText,
  topTitle,
  packageList,
  numberColumns,
  layoutAligned,
  showExpendPackage,
  showAccountBalance,
  slideshowRefs,
}) => (
  <FullPageSimulator
    globJSON={globJSON}
    simPlatform={simPlatform}
    headlineText={headlineText}
    TopTitle={showExpendPackage && topTitle}
    floatingChildren={[showExpendPackage && <BottomPanelButton globJSON={globJSON} text="Or enter other amount" />]}
    slideshowRefs={slideshowRefs}
  >
    {showAccountBalance && (
    <AccountBalance
      globJSON={globJSON}
      showExpendBox
    />
    )}
    <View style={{
      flexDirection: 'row', flexWrap: 'wrap', paddingHorizontal: 15, marginBottom: 20, marginTop: 10,
    }}
    >
      {packageList.map((packageObject) => (
        <PackageCard
          globJSON={globJSON}
          packageObject={packageObject}
          numberColumns={numberColumns}
          layoutAligned={layoutAligned}
        />
      ))}
    </View>

  </FullPageSimulator>
);

export default SelectOperatorFP;
